var exports = {
  "x": "triggerContents__p0h0Yd",
  "i": "descriptionText__M6kqvD",
};

module.exports = exports;
